import * as React from "react";
import { Icon, Typography } from "../ecosystem";
import { getDirectionsUrl } from "../../helpers/location";
import * as Tools from "../../helpers/Tools";
import Rating, { RatingCount, Stars } from "../common/Rating";
import moment from "moment-timezone";

const DATE_FORMAT = Tools.getDateFormats();
const DATE_FORMAT_YYYY_MM_DD = "YYYY-MM-DD";

export default class VerifyAndSchedule extends React.Component {
  constructor(props) {
    super(props);
  }

  onEditClick = (e) => {
    if (e) {
      e.preventDefault();
    }
    const {
      stepManager,
      goBack,
      isNonMyChartUser,
      apptInfoStepValue,
    } = this.props;
    goBack(apptInfoStepValue);
    //  this.props.goBack(this.props.stepManager.state.currentStep - 1);
    // goBack(isNonMyChartUser ? stepManager.state.currentStep -2: stepManager.state.currentStep - 1);
  };

  onGoNext(success) {
    if (success) {
      const visit = this.props.visit;
      const date = moment(visit.date).format(DATE_FORMAT_YYYY_MM_DD);
        visit.date = date;
        visit.reasonForVisit = visit.reasonForVisit !== "" ? visit.reasonForVisit : visit.reasonForVisitValue;
      this.props.saveStepInfo({ visit: visit });
      if (this.props.onSubmit) {
        this.props.onSubmit();
      }
    } else {
      this.setState({ showAsInvalid: true });
    }
  }

  getDayOfWeek = (x) => {
    var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    if (Object.prototype.toString.call(dt) === "[object Date]") {
      var strDay = weekday[dt.getDay()];
      return strDay;
    }
    return "Invalid Date";
  };
  date2str = (x) => {
    var dt = Tools.toJSDate(`${x}T00:00:00`, DATE_FORMAT);
    const dayName = dt.getDate();
    let monthName = dt.getMonth() + 1;
    if (monthName < 10) monthName = "0" + monthName;
    return `${Tools.getMonthName(monthName.toString())} ${dayName}`;
  };

  formatTime = (s) => {
    let parts = s.split(":");
    let ret = s;
    if (parts.length >= 2) {
      let h = parseInt(parts[0]);
      let m = parseInt(parts[1]);
      let s = parseInt(parts[2]);

      let ispm = h >= 12;
      h = h > 12 ? h - 12 : h;

      ret = `${h.toString()}:${m.toString().padStart(2, "0")} ${
        ispm ? "PM" : "AM"
      }`;
    }
    return ret;
  };

  redirectToMap = (item) => {
    if (item.Address) {
      const toAddress =
        item.Address.locationStreet1 +
        ", " +
        item.Address.locationCity +
        ", " +
        item.Address.locationState +
        " " +
        item.Address.locationZip;
      var addressUrl = getDirectionsUrl(null, toAddress);
      if (typeof window !== "undefined" && addressUrl) {
        window.open(addressUrl, "_blank");
      }
    }
  };

  render() {
    const {
      provider,
      goBack,
      departments,
      providerDetails,
      visit,
      style,
      isMobile,
    } = this.props;
    const selectedDepartmentId = visit.department.id;
    const address =
      selectedDepartmentId && departments
        ? departments.find(
            (item) => item.value.indexOf(selectedDepartmentId) >= 0
          )
        : undefined;
    const prov = {
      photo: provider ? provider.photoUrl : "",
      averageRatingStr: provider ? provider.averageRating : 0,
      reviewCountStr: provider ? provider.ratingCount : 0,
      displayName: provider ? provider.displayName : "", // Jason: you can just populate this from props; also look at care/FindCareResults for how to use StarRatings, etc.
      specialty: provider ? provider.specialty : "",
      Address: {
        locationStreet1: address ? address.address1 : "",
        locationStreet2: address ? address.address2 : "",
        locationCity: address ? address.city : "",
        locationState: address ? address.state : "",
        locationZip: address ? address.zip : "",
      },
    };
    const appt = {
      TimeString: visit.time && this.formatTime(visit.time),
      DayString: visit.date && this.getDayOfWeek(visit.date),
      DateString: this.date2str(visit.date),
    };
    const provPhoto = prov.photo ? prov.photo : "/images/profile-pic.png";
    const defaultPhone =
      providerDetails && providerDetails.consumerCallCenterNumber
        ? providerDetails.consumerCallCenterNumber
        : visit.department
        ? visit.department.phone
        : "";
    const patientStatus =
      visit && visit.acceptType === "Existing"
        ? "Established Patient"
              : "New Patient";
    const visitReasonDesc = visit.reasonForVisit && visit.reasonForVisit === visit.reasonForVisitValue && visit.reasonForVisitValue ? "" : visit.reasonForVisit;

    return (
      <div
        className="schedule-visit-reason-container verifyandschedule-provider-workflow"
        style={style}
      >
        <div className="row">
          <div className="col-12">
            <h1 className="step-heading">
              {isMobile ? (
                <Typography type={"heading-03"}>
                  Almost done! How does everything look?
                </Typography>
              ) : (
                <>Almost done! How does everything look?</>
              )}
            </h1>
          </div>
        </div>
        <div className="row appt-details-mobile confirm-appt-details-container">
          <div className="co-4 visit-details-mobile">
            <div className="visit-day">
              <Typography type={"meta-01"} color="$color-primary-a2">
                {appt.DayString}
              </Typography>
            </div>
            <div className="visit-month">
              <Typography type={"heading-03"} color="$color-primary-a3" bold>
                {appt.DateString}
              </Typography>
            </div>
          </div>
          <div className="col-6 appointment-details-mobile">
            <div className="appoint-label">
              <Typography type={"meta-01"} color="$color-primary-a2">
                Appointment time
              </Typography>
            </div>
            <div className="visit-time">
              <Typography type={"heading-03"} color="$color-primary-a3" bold>
                {appt.TimeString}
              </Typography>
            </div>
          </div>
          <div
            className="col-2 edit-appointement"
            onClick={(e) => this.onEditClick(e)}
          >
            <Typography type="cta-03" color="$color-primary-a3" bold>
              Edit
              <span className="icon-edit" />
            </Typography>
          </div>
        </div>
        <div className="row confirm-appt-details-container">
          <div className="col-12 col-lg-6 confirm-dr-details">
            <div className="row confirm-dr-details-content">
              <div className="col-3 col-lg-3 item-avatar-container">
                <div
                  className="item-img-container"
                  style={{ backgroundImage: `url(${provPhoto})` }}
                >
                  <div className="item-img" />
                </div>
                {prov.averageRatingStr &&
                  prov.averageRatingStr !== "" &&
                  prov.averageRatingStr !== "0" && (
                    <Rating
                      align="bottom"
                      isRatingCount
                      isAverageRatingCount
                      reviewCount={prov.reviewCountStr}
                      starDimension="12px"
                      averageRating={prov.averageRatingStr}
                    >
                      <Stars />
                      <RatingCount  ratingCountClassName={isMobile?"d-none":""}/>
                    </Rating>
                  )}
              </div>
              <div className="col-9 col-lg-9 appt-item-details">
                <div className="row">
                  <div className="col-12 item-name">
                    {prov.displayName}
                    <br />
                    <span className="item-specialty">{prov.specialty}</span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 item-location">
                    <a
                      tabIndex="0"
                      className={prov.Address ? "directions-link" : "no-link"}
                      onClick={() => this.redirectToMap(prov)}
                    >
                      <div className="details-icon-prepend">
                        <div className="icon-col">
                          <Icon name="location" color={"$color-primary-a2"} />
                        </div>
                        <div className="details-col">
                          {prov.Address ? (
                            isMobile ? (
                              <div>
                                <div>
                                  <Typography type="body-01">
                                    {prov.Address.locationStreet1}
                                  </Typography>
                                  {prov.Address.locationStreet2 && (
                                    <span>
                                      <Typography type="body-01">
                                        ,{prov.Address.locationStreet2},
                                      </Typography>
                                    </span>
                                  )}
                                </div>
                                <div>
                                  <Typography type="body-01">
                                    {prov.Address.locationCity}, 
                                    {prov.Address.locationState}
                                    {prov.Address.locationZip}
                                  </Typography>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <div>
                                  {prov.Address.locationStreet1}
                                  {prov.Address.locationStreet2 && (
                                    <span>
                                      , {prov.Address.locationStreet2},
                                    </span>
                                  )}
                                </div>
                                <div>
                                  {prov.Address.locationCity},
                                  {prov.Address.locationState}
                                  {prov.Address.locationZip}
                                </div>
                              </div>
                            )
                          ) : (
                            <div className="no-data-dash">
                              <div />
                            </div>
                          )}
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 item-phone">
                    <a
                      className={defaultPhone ? "phone-link" : "no-link"}
                      href={defaultPhone ? "tel:" + defaultPhone : "#"}
                    >
                      <div className="details-icon-prepend">
                        <div className="icon-col icon-col-patient">
                          <Icon name="phone" color={"$color-primary-a2"} />
                        </div>
                        <div className="details-col">
                          {defaultPhone ? (
                            <div>
                              {isMobile ? (
                                <Typography type="body-01">
                                  {defaultPhone}
                                </Typography>
                              ) : (
                                defaultPhone
                              )}
                            </div>
                          ) : (
                            <div className="no-data-dash">
                              <div />
                            </div>
                          )}
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 item-phone">
                    <div className="details-icon-prepend">
                      <div className="icon-col icon-col-patient">
                        {patientStatus === "Established Patient" ? (
                          <Icon name="patient" color={"$color-primary-a2"} />
                        ) : (
                          <Icon
                            name="new-patient"
                            color={"$color-primary-a2"}
                          />
                        )}
                      </div>
                      <div className="details-col">
                        {visit.visitType ? (
                          <div>
                            {isMobile ? (
                              <Typography type="body-01">
                                {patientStatus}
                              </Typography>
                            ) : (
                              patientStatus
                            )}
                          </div>
                        ) : (
                          <div className="no-data-dash">
                            <div />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-2 confirm-visit-details">
            <div className="visit-day">
              <Typography type={"heading-01"} color="$color-primary-a2">
                {appt.DayString}
              </Typography>
            </div>
            <div className="visit-month">
              <Typography type={"heading-06"} color="$color-primary-a3" bold>
                {appt.DateString}
              </Typography>
            </div>
          </div>
          <div className="col-lg-4 appointment-details">
            <div className="appoint-label">
              <Typography type={"heading-01"} color="$color-primary-a2">
                Appointment time
              </Typography>
            </div>
            <div className="appoint-time">
              <div className="visit-time">
                <Typography type={"heading-06"} color="$color-primary-a3" bold>
                  {appt.TimeString}
                </Typography>
              </div>
              <div
                className="edit-appointement"
                onClick={(e) => this.onEditClick(e)}
              >
                <Typography type={"heading-01"} color="$color-primary-a3" bold>
                  Edit
                  <span className="icon-edit" />
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div className="row reason-content">
          <div className="col-12 reason-title">Main Concern</div>
          <div className="col-12 reason-subtitle">
            {visit.reasonForVisitValue}
          </div>
          <div className="col-12">
                    <p className="reason-desc">{visitReasonDesc}</p>
          </div>
        </div>
        <div className="row schedule-provider-info">
          <div className="col-12 schedule-provider-content">
            <span className="icon-info-filled"></span>
            <div className="info-message">
              Before your appointment, please verify with your insurance carrier
              the nature and extent of the coverage, services, facilities, and
              providers that will be considered in-network.
            </div>
          </div>
        </div>
      </div>
    );
  }
}
